import styled from "styled-components";

// Full-window overlay, portaled to <body> so it escapes the Stage's scaled
// 1920×1080 canvas and its letterbox — the media covers the ENTIRE screen with
// no background showing, on any aspect ratio.
export const StartOverlay = styled.div`
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000;
  z-index: 100000;
  pointer-events: none;
`;

// Fallback (no media set): a normal in-canvas 1920×1080 screen with the button
// over the app's Stage background.
export const StartContainer = styled.div`
  position: absolute;
  width: 1920px;
  height: 1080px;
  left: 0;
  top: 0;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
`;

// Uploaded image, covering the whole window.
export const StartMediaImg = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  user-select: none;
  pointer-events: none;
`;

// Uploaded .mp4, covering the whole window (autoplay + muted + loop).
export const StartVideo = styled.video`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  user-select: none;
  pointer-events: none;
`;

// The START button (class .start-button) is styled entirely from the admin
// Config page — Start.jsx injects that CSS at runtime. No bundled stylesheet;
// the default lives server-side in ConfigController::DEFAULT_START_BUTTON_CSS.
